// import { Button, Flex, Form, Input } from "antd";
// import { useEffect } from "react";

// const DeviceTypeForm = (props) => {
//   const [form] = Form.useForm();

//   useEffect(() => {
//     if (props.editData) {
//       form.setFieldsValue({
//         deviceType: props.editData.deviceType,
//       });
//     } else {
//       form.resetFields();
//     }
//   }, [props.editData, form]);

//   return (
//     <Form
//       form={form}
//       layout="vertical"
//       style={{ maxWidth: 600 }}
//       onFinish={(data) =>
//         props.saveData({ ...props.editData, ...data }).then((success) => {
//           if (success) {
//             form.resetFields();
//           }
//         })
//       }
//     >
//       <Form.Item
//         label="Device Type"
//         name="deviceType"
//         rules={[{ required: true, message: "Please input device type name!" }]}
//       >
//         <Input />
//       </Form.Item>{" "}
//       <Form.Item
//         label="Device idendification number"
//         name="deviceIdentificationNumber"
//         rules={[
//           {
//             required: true,
//             message: "Please input device idendification number!",
//           },
//         ]}
//       >
//         <Input />
//       </Form.Item>
//       <Flex justify="end">
//         <Button type="primary" htmlType="submit">
//           Submit
//         </Button>
//       </Flex>
//     </Form>
//   );
// };

// export default DeviceTypeForm;
import { Button, Flex, Form, Input } from "antd";
import { useEffect } from "react";

const LOCAL_STORAGE_KEY = "deviceIdentificationNumber";

const DeviceTypeForm = (props) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (props.editData) {
      form.setFieldsValue({
        deviceType: props.editData.deviceType,
        deviceIdentificationNumber:
          localStorage.getItem(LOCAL_STORAGE_KEY) || "",
      });
    } else {
      form.resetFields();
      form.setFieldValue(
        "deviceIdentificationNumber",
        localStorage.getItem(LOCAL_STORAGE_KEY) || ""
      );
    }
  }, [props.editData, form]);

  const handleFinish = (data) => {
    const { deviceIdentificationNumber, ...backendPayload } = data;

    // 👉 Store only in localStorage
    localStorage.setItem(LOCAL_STORAGE_KEY, deviceIdentificationNumber);

    // 👉 Send only required fields to backend
    return props
      .saveData({ ...props.editData, ...backendPayload })
      .then((success) => {
        if (success) {
          form.resetFields();
          form.setFieldValue(
            "deviceIdentificationNumber",
            localStorage.getItem(LOCAL_STORAGE_KEY)
          );
        }
      });
  };

  return (
    <Form
      form={form}
      layout="vertical"
      style={{ maxWidth: 600 }}
      onFinish={handleFinish}
    >
      <Form.Item
        label="Device Type"
        name="deviceType"
        rules={[{ required: true, message: "Please input device type name!" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Device identification number"
        name="deviceIdentificationNumber"
        rules={[
          {
            required: true,
            message: "Please input device identification number!",
          },
        ]}
      >
        <Input />
      </Form.Item>

      <Flex justify="end">
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Flex>
    </Form>
  );
};

export default DeviceTypeForm;
